import React, { useState, useEffect } from "react";
import { Badge } from "react-bootstrap";
import { useGetSoilParametersQuery } from "./RiskManagementApiSlice";
import { Card, Table, CardBody, CardHeader } from "reactstrap";
import { store } from "app/store";
import axios from "axios";
import { API_URL } from "app/config";
export const RiskSoilDetails = ({ id, plotId }) => {
  //   const { data: SoilParameters, isLoading, error } = useGetSoilParametersQuery({ id, plotId });
  const [soilData, setSoilData] = useState([]);
  //   useEffect(() => {
  //     setSoilData(SoilParameters?.data?.results || []);
  //   }, [SoilParameters]);

  const refetch = async () => {
    const state = store.getState();
    try {
      const response = await axios.get(
        `${API_URL}/survey/soil-parameters/?FarmerId=${id}&PlotId=${plotId}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response", response?.data?.data);
      const results = response?.data?.data?.results || [];

      setSoilData(results || []);
    } catch (error) {
      console.error("Error fetching farmer data:", error);
      throw error;
    }
  };
  useEffect(() => {
    refetch();
  }, [id, plotId]);

  const getBadgeColor = (value) => {
    const num = parseInt(value);
    if (isNaN(num)) return "secondary";
    if (num < 50) return "success"; // green
    if (num < 100) return "warning"; // orange
    return "danger"; // red
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "-";
    }
  };

  return (
    <div>
      {soilData?.length > 0 && (
        <Card>
          <CardHeader>
            <div className="relative w-full">
              <h5 className="flex items-center justify-between rounded-top p-1 pr-10">
                Soil Parameters
              </h5>
            </div>
          </CardHeader>
          <CardBody className="p-lg-3 p-md-3 p-0">
            <div className="d-none d-md-block">
              <Table hover className="align-middle mb-0">
                <thead className="table-light text-center">
                  <tr>
                    <th>Date</th>
                    <th>N | P | K</th>
                    <th>Moisture</th>
                    <th>Temperature</th>
                    <th>EC Value</th>
                    <th>PH Value</th>
                  </tr>
                </thead>
                <tbody>
                  {soilData?.map((item) => {
                    const {
                      nValue,
                      pValue,
                      kValue,
                      moisture,
                      ecValue,
                      temperature,
                      pHValue,
                    } = item.Parameters;
                    return (
                      <tr key={item.Id} className="text-center">
                        <td className="fw-semibold">
                          {item.CreatedOn.slice(0, 10)}
                        </td>
                        <td>
                          {/* <Badge bg={getBadgeColor(nValue)} className="mx-1">
                            N: {nValue || "-"}
                          </Badge>
                          <Badge bg={getBadgeColor(pValue)} className="mx-1">
                            P: {pValue || "-"}
                          </Badge>
                          <Badge bg={getBadgeColor(kValue)} className="mx-1">
                            K: {kValue || "-"}
                          </Badge>
                          <td> */}
  <Badge className="badge green mx-1">
    N: {nValue || "-"}
  </Badge>

  <Badge className="badge orange mx-1">
    P: {pValue || "-"}
  </Badge>

  <Badge className="badge red mx-1">
    K: {kValue || "-"}
  </Badge>
{/* </td> */}

                        </td>
                        <td>{moisture || "-"}</td>
                        <td>{temperature || "-"}</td>
                        <td>{ecValue || "-"}</td>
                        <td>{pHValue || "-"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
            <div className="d-block d-md-none">
              <div className="d-flex flex-column gap-3 p-1">
                {soilData?.map((item) => {
                  const {
                    nValue,
                    pValue,
                    kValue,
                    moisture,
                    ecValue,
                    temperature,
                    pHValue,
                  } = item.Parameters;
                  return (
                    <>
                      <div className="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                        <div className="fw-semibold p-2">
                          Date: {item.CreatedOn.slice(0, 10)}
                        </div>
                        <div className="mb-1">
                          <Badge bg={getBadgeColor(nValue)} className="me-1">
                            N: {nValue || "-"}
                          </Badge>
                          <Badge bg={getBadgeColor(pValue)} className="me-1">
                            P: {pValue || "-"}
                          </Badge>
                          <Badge bg={getBadgeColor(kValue)} className="me-1">
                            K: {kValue || "-"}
                          </Badge>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap p-2">
                        <div>Moisture: {moisture || "-"}</div>
                        <div>Temperature: {temperature || "-"}</div>
                      </div>
                      <div className="d-flex justify-content-between align-items-center flex-wrap p-2">
                        <div>EC Value: {ecValue || "-"}</div>
                        <div>PH Value: {pHValue || "-"}</div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </CardBody>
        </Card>
      )}

      {/* {soilData?.length > 0 ? (
       <Card className="">
           <CardHeader>
                     <div className="relative w-full">
                        <h5 className="flex items-center justify-between rounded-top p-1 pr-10">
                        Soil Parameters
                        </h5>
                      </div>
                    </CardHeader>
           <CardBody className="p-2">
        
                    <Table className="table mb-4">
             
              <tbody>
                {soilData.map((item, index) => {
                  const { nValue, pValue, kValue ,moisture,ecValue,temperature} = item.Parameters;
                  return (
                    <tr key={item.Id}>
                          <th>Date</th>
                          <td><b>{item.CreatedOn.slice(0,10)}</b></td>
                           <th>Moisture</th>
                          <td><b>{moisture}</b></td> <th>EcValue </th>
                          <td><b>{ecValue}</b></td> <th>Temperature</th>
                          <td><b>{temperature}</b></td>
                         <th>N | P | K</th>
                      <td>
                        <Badge bg={getBadgeColor(nValue)} className="mx-1">{nValue || "-"}</Badge>
                        <Badge bg={getBadgeColor(pValue)} className="mx-1">{pValue || "-"}</Badge>
                        <Badge bg={getBadgeColor(kValue)} className="mx-1">{kValue || "-"}</Badge>
                      </td>
                                              
                    </tr>
                  );
                })}
              </tbody>
            </Table>



         
    </CardBody></Card>
       ):""}  */}
    </div>
  );
};
